export const SET_HIDE_NAVBAR = "SET_HIDE_NAVBAR";


export const setHideNavbar = () => ({
  type: SET_HIDE_NAVBAR,
});

